export default __webpack_public_path__ + "images/add-plus-icon.svg";